import request from '@/utils/request'

export function trackingLogs(params) {
	return request({
		url: '/admin/track-log',
		method: 'get',
		params: params
	});
}

export function getTrackActions() {
	return request({
		url: '/admin/track-log/actions',
		method: 'get'
	});
}

export function toggleCaptureToDB() {
	return request({
		url: '/admin/track-log/toggle-capture-to-db-setting',
		method: 'post',
		data: {}
	});
}

export async function trackingLogsExport(params) {
	const response = await request({
		url: '/admin/track-log/export',
		method: 'GET',
		params: params,
		responseType: 'blob',
	});
	const url = window.URL.createObjectURL(new Blob([response.data]));
	return url;
}